/*------------------------------------*\
    FILTERS
\*------------------------------------*/
class Filters {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.toggle = self.elem.querySelector('[data-filters-toggle]');
        self.panel = self.elem.querySelector('[data-filters-panel]');
        self.isOpen = false;
    }

    init() {
        let self = this;

        // Check if panel should be open on page load
        if (self.elem.hasAttribute('data-open-on-load')) {
            self.openPanel();
        }

        // On click on filters button
        self.toggle.addEventListener('click', evt => {
            if (self.isOpen) {
                self.closePanel();
            } else {
                self.openPanel();
            }
        });
    }

    openPanel() {
        let self = this;

        self.panel.classList.add('is-open');
        self.toggle.setAttribute('aria-expanded', true);
        self.isOpen = true;
    }

    closePanel() {
        let self = this;

        self.panel.classList.remove('is-open');
        self.toggle.setAttribute('aria-expanded', false);
        self.isOpen = false;
    }
}

export default Filters;
